module.exports = __webpack_public_path__ + "static/media/openshift.867253d1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/openshift.png
// module id = 161
// module chunks = 0